<template>
  <div>
    <b-modal
      v-model="dialog"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Add Recherche List</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>

      <div v-if="loadingRecherchelistnames">
        <b-spinner small label="Small Spinner" type="grow"></b-spinner><small> Loading Data...</small>
      </div>

      <dx-autocomplete
        :data-source="savedListsNames"
        class="my-2"
        v-model="recherchelistSearch"
        :show-clear-button="true"
        :min-search-length="3"
        placeholder="Search by Listname..."
        :onItemClick="searchByListname"
        :disabled="loadingRecherchelistnames"
      />

      <div v-if="loadingLists">
        <b-spinner small label="Small Spinner" type="grow"></b-spinner><small> Loading Recherchelists...</small>
      </div>

      <dx-select-box
        v-if="allSavedLists.length"
        :search-enabled="true"
        :data-source="allSavedLists"
        display-expr="bezeichnung"
        value-expr="field_001"
        class="mb-4"
        @value-changed="selectedValue"
        item-template="item"
        v-model="selectedListItem"
      >
        <template #item="{ data }">
          <div>
            ({{data.field_001}}) - {{ data.bezeichnung }}
          </div>
        </template>
      </dx-select-box>

      <div class="mt-3">
        <div class="my-4" v-show="!disableBtn">
          <small>The addition may take a moment depending on the amount of data.</small>
          <p class="mt-2"><small><strong>After addition:</strong><br>green: The entry matches the address search<br>orange: The entry is from the saved list, but doesn't match</small></p>
        </div>
        <div class="btn-container">
          <b-button type="submit" variant="primary" class="mt-1 ok-btn" size="sm" disabled v-if="isSubmitting">
            <b-spinner small></b-spinner>
            Adding List to Pool
          </b-button>
          <b-button
            :disabled="disableBtn"
            variant="primary"
            class="mt-1 ok-btn"
            size="sm"
            @click="loadRecherchelist"
            v-else
          >Add List to Pool
          </b-button>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DxAutocomplete } from 'devextreme-vue/autocomplete'
  import DxSelectBox from 'devextreme-vue/select-box'
  import { highlightingAttributesList } from '@/components/recherche/rechercheSearch/variables.js'
  export default {
    name: 'add-template',
    components: {
      DxSelectBox,
      DxAutocomplete
    },
    props: {
      template: Object
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false,
        recherchelistSearch: '',
        loadingLists: false,
        disableBtn: true,
        selectedSavedListId: null,
        searchCompleted: false,
        loadingRecherchelistnames: false,
        dialog: false,
        selectedListItem: null,
        selectedSavedList: null
      }
    },
    mounted () {
      this.$store.commit('recherche/SET_SAVEDLISTS_NAMES', [])
      this.$store.commit('recherche/SET_SAVEDLISTS', [])
      this.searchCompleted = false
      this.selectedSavedListId = null
      this.onGetRecherchelistNames()
    },
    methods: {
      openModal () {
        this.dialog = true
        this.disableBtn = true
      },
      resetForm () {
        this.$store.commit('recherche/SET_SAVEDLISTS_NAMES', [])
        this.$store.commit('recherche/SET_SAVEDLISTS', [])
        this.recherchelistSearch = ''
        this.searchCompleted = false
        this.selectedSavedListId = null
        if (this.savedListsNames.length < 1) {
          this.loadingRecherchelistnames = true
          this.onGetRecherchelistNames()
        }
      },
      searchByListname () {
        if (this.recherchelistSearch !== '') {
          this.getSavedLists()
        }
      },
      selectedValue (val) {
        this.selectedSavedListId = val.value
        this.disableBtn = false
        this.selectedSavedList = this.allSavedLists.find(el => el.field_001 === this.selectedSavedListId)
      },
      loadRecherchelist () {
        this.getSaveListItemsById(this.selectedSavedListId)
      },
      async getSaveListItemsById (id) {
        this.isSubmitting = true
        try {
          const { errors } = await this.$store.dispatch('recherche/GET_ADDRESSLISTS_BY_ID_POOL', { id })
          if (errors) throw errors
          this.getIdAndLoadFromMS()
        } catch (err) {
          this.hasError = true
          this.searchCompleted = true
          this.isSubmitting = false
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      getIdAndLoadFromMS () {
        const ArrayOfIds = []
        this.crmAdresslist.cRMRechercheAdresslisteAdressen.forEach(element => {
          if (element.cRMAddress) {
            ArrayOfIds.push(element.cRMAddress.field_001)
          }
        })
        const preparedIdFilter = this.preparingFilterStructure(ArrayOfIds, 'id')
        this.fetchMeiliSearchData(preparedIdFilter, ArrayOfIds.length)
      },
      preparingFilterStructure (selectedFilters, filterField) {
        let filterStructure = ''
        for (const el in selectedFilters) {
          if (filterStructure === '') {
            filterStructure += `${filterField} = ${selectedFilters[el]}`
          } else {
            filterStructure += ` OR ${filterField} = ${selectedFilters[el]}`
          }
        }
        return filterStructure
      },
      fetchMeiliSearchData (preparedIdFilter, totalCount) {
        return fetch(`https://app-meilisearch-prod-001.azurewebsites.net/indexes/${process.env.VUE_APP_MEILISEARCH_INDEX}/search`,
                     {
                       method: 'POST',
                       headers: {
                         'Content-Type': 'application/json',
                         Authorization: `Bearer ${process.env.VUE_APP_MEILISEARCH_TOKEN}`
                       },
                       body: JSON.stringify({
                         q: '',
                         attributesToHighlight: highlightingAttributesList,
                         limit: totalCount,
                         offset: 0,
                         filter: (preparedIdFilter)
                       })
                     })
          .then(response => response.json())
          .then((data) => {
            this.isSubmitting = false
            this.closeModal()
            setTimeout(() => {
              for (const el in data.hits) {
                data.hits[el].sourceSavedList = true
                data.hits[el].sourceSearchList = false
              }
              this.$emit('mergeRechercheListWithPoolData', data.hits)
              this.$emit('addImportedList', this.selectedSavedList)
              return {
                data: data.hits,
                totalCount: data.estimatedTotalHits
              }
            }, 1000)
          })
          .catch((err) => {
            this.isSubmitting = false
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
            throw err
          })
      },
      async getSavedLists () {
        this.$store.commit('recherche/SET_SAVEDLISTS', [])
        this.loadingLists = true
        try {
          const { errors } = await this.$store.dispatch('recherche/GET_SAVELISTS', this.recherchelistSearch)
          if (errors) throw errors
          else {
            this.loadingLists = false
            this.searchCompleted = true
            this.selectedListItem = this.allSavedLists[0].field_001
          }
        } catch (err) {
          this.hasError = true
          this.loadingLists = false
          this.searchCompleted = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async onGetRecherchelistNames () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('recherche/GET_SAVEDLISTS_NAMES')
          if (errors) throw errors
          this.loadingRecherchelistnames = false
        } catch (err) {
          this.hasError = true
          this.loadingRecherchelistnames = false
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          this.loadingShow = false
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      closeModal () {
        this.dialog = false
      }
    },
    computed: {
      ...mapGetters({
        allSavedLists: 'recherche/SAVEDLISTS',
        savedListsNames: 'recherche/SAVEDLISTS_NAMES',
        crmAdresslist: 'recherche/ADDRESSLISTS'
      })
    }
  }
</script>
<style lang="scss">
.btn-container {
  display: flex;

  .ok-btn {
    margin-left: auto;
    margin-right: 0;
  }
}

.blue-highlight {
  color: #007bff;
}

.orange-highlight {
  color: orangered;
}
</style>
